var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUngroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.217 15.174V12.68h1.557c.354 0 .642-.29.642-.644V8.093a.644.644 0 0 0-.642-.644h-3.931a.644.644 0 0 0-.643.644v1.561h-4.41V5.233h1.557c.355 0 .642-.29.642-.644V.645a.644.644 0 0 0-.642-.644h-3.931a.645.645 0 0 0-.643.644v1.562H5.267V.645A.644.644 0 0 0 4.625 0H.694a.644.644 0 0 0-.642.644v3.944c0 .354.288.643.642.643H2.25v9.401H.694a.644.644 0 0 0-.642.644v3.943c0 .355.288.644.642.644h3.931a.643.643 0 0 0 .642-.644v-1.364H7.82v-.001h1.856v4.225H8.119a.643.643 0 0 0-.642.644v3.943c0 .356.288.644.642.644h3.932a.644.644 0 0 0 .642-.644v-1.363H22.2v1.364c0 .355.287.644.642.644h3.932c.353 0 .642-.29.642-.644v-3.944a.644.644 0 0 0-.642-.643h-1.558v-6.907h.002zm-2.2-6.906h3.581v3.592h-3.581V8.268zm-17.75 8.767v-1.758a.643.643 0 0 0-.642-.644H3.068V5.232h1.557c.354 0 .641-.29.641-.643V3.027h9.507V4.59c0 .354.289.643.642.643h1.558v4.422h-4.279V8.093a.644.644 0 0 0-.641-.644H8.12a.644.644 0 0 0-.642.644v3.943c0 .354.287.644.642.644h1.557v4.355H5.267zm4.41-5.176H8.295V8.27h3.582v3.59h-2.2zm2.2 14.632H8.294V22.9h3.581v3.591zm14.72 0h-3.58v-3.59h3.58v3.59zm-2.198-4.41h-1.557a.644.644 0 0 0-.643.643v1.76h-9.505v-1.76a.644.644 0 0 0-.642-.644h-1.557v-9.4h1.557c.353 0 .642-.29.642-.645v-1.561h9.505v1.561c0 .355.288.644.643.644h1.557v9.401z",
    fill: "#000",
    fillRule: "nonzero",
    opacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUngroup);
export default __webpack_public_path__ + "static/media/ungroup.844747f8a21f8da3a4feaea0947942e6.svg";
export { ForwardRef as ReactComponent };